import { useEffect, useState } from "react";
import { getNews } from "../../app/api";
import { Link } from "react-router-dom";
import { Pagination } from "antd";

const HTMLTextView = ({ htmlContent }: any) => {
  return (
    <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
  );
};

export const News = () => {
  const [loading, setLoading] = useState(false);
  const pageSize = 8;
  const [Data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [totalCount, setTotalCount] = useState<number | undefined>(undefined);

  useEffect(() => {
    setLoading(true);
    try {
      const q = {
        offset: ((page-1)*pageSize).toString(),
        limit: (pageSize).toString(),
      }
      const params = new URLSearchParams(q);
  
      getNews(params).then((res: any) => {
        setData(res.data.results);
        setTotalCount(res.data.total);
      });
    } catch(err) {
    }
    setLoading(false);
  }, [page, totalCount]);

  return (
    <div className="mx-auto max-w-7xl p-10 pt-[140px] flex flex-col justify-center ">
      {loading &&
        <div className="w-full h-full fixed top-0 left-0 bg-white opacity-75 z-50">
          <div className="flex justify-center items-center mt-[50vh]">
            <div role="status" className="absolute -translate-x-1/2 -translate-y-1/2 top-2/4 left-1/2">
              <svg aria-hidden="true" className="w-24 h-24 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/><path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/></svg>
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        </div>
      }
      <div className="mb-10 mx-auto max-w-2xl text-center">
          <h2 className="text-3xl font-bold tracking-tight text-[#003463] sm:text-4xl italic mb-4">
              Мэдээ, мэдээлэл
          </h2>
      </div>
      {Data.map((news: any) =>
        <>
          <div className="mb-10 flex flex-wrap">
            <div className="mb-6 ml-auto w-full shrink-0 grow-0 basis-auto px-3 md:mb-0 md:w-3/12">
              <div className="h-full relative mb-6 overflow-hidden rounded-lg bg-cover bg-no-repeat shadow-lg dark:shadow-black/20"
                data-te-ripple-init data-te-ripple-color="light">
                {news.type === "Зураг" || news.type === "Бичлэг" ?
                    <p className="absolute right-0 bg-[#07B2EC] px-4 rounded-2xl text-white mt-2 mr-2">
                        {news.type}
                    </p> :
                    <p className="absolute right-0 bg-[#FF4433] px-4 rounded-2xl text-white mt-2 mr-2">
                        {news.type}
                    </p>
                }
                <img src={news.thumb} className="h-full object-cover" alt="news" />
                <Link to={`/news/${news.id}`}>
                  <div
                    className="absolute top-0 right-0 bottom-0 left-0 h-full w-full overflow-hidden bg-fixed opacity-0 transition duration-300 ease-in-out hover:opacity-100 bg-[hsla(0,0%,98.4%,.15)]">
                  </div>
                </Link>
              </div>
            </div>

            <div className="mb-6 mr-auto w-full shrink-0 grow-0 basis-auto px-3 md:mb-0 md:w-9/12 xl:w-7/12">
              <h5 className="text-lg font-bold">{news.title}</h5>
              <p className="mb-3">
                <small>{new Date(news.createdAt).toLocaleDateString('mn')}</small>
              </p>
              <p className="mb-6 line-clamp-4">
                <HTMLTextView htmlContent={news.content}/>
              </p>

              <Link to={`/news/${news.id}`}>
                <button className="rounded-full bg-[#07B2EC] px-6 py-2 text-sm font-semibold text-white mr-4">
                  Цааш унших
                </button>
              </Link>
            </div>
          </div>
        </>
      )}
      <div className="flex flex-row place-content-center">
        <Pagination defaultCurrent={page} pageSize={pageSize} total={totalCount} onChange={(page, pageSize) => {
          setPage(page);
        }}/>
      </div>
    </div>
  )
}

export default News;